import React, { useState, useCallback } from 'react';
import Navigation from '../Navigation/Navigation';
import Footer from '../Footer/Footer.js';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import './PhotoGallery.css';

function PhotoGallery() {
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);

    const importAll = (r) => {
        return r.keys().map((item) => {
            const module = r(item);
            const imagePath = module.default || module;
            console.log('Loaded image path:', imagePath);
            return imagePath;
        });
    };
    
    const images = importAll(require.context('../../images/PhotoGallery/', false, /\.(png|jpe?g|svg)$/));
    
    // Format images for Yet Another React Lightbox
    const lightboxImages = images.map(src => ({ src }));

    const openImageViewer = useCallback((index) => {
        setCurrentImage(index);
        setIsViewerOpen(true);
    }, []);
     
    const closeImageViewer = () => {
        setIsViewerOpen(false);
    };

    return (
        <div className="gallery">
            <h2>Photo Gallery</h2>
            <div className="photos">
                {images.map((src, index) => (
                    <div className="photo" key={index}>
                        <img
                            src={src}
                            onClick={() => openImageViewer(index)}
                            alt={`Gallery image ${index + 1}`}
                        />
                    </div>
                ))}
                
                {isViewerOpen && (
                    <Lightbox
                        open={isViewerOpen}
                        close={closeImageViewer}
                        slides={lightboxImages}
                        index={currentImage}
                    />
                )}
            </div>
            <Footer />
        </div>
    );
}

export default PhotoGallery;